/**
 * abstract class for information needed by each cell of document manager
 */

export default class DataItem {
  constructor(
    id,
    dadId,
    order,
    getComponent,
    getHeader,
    name,
    getEmptyFolderComponent = null,
    isEditable = true,
    type = null,
    hidden = false,
    status = 'exists'
  ) {
    this.id = id;
    this.dadId = dadId;
    this.order = order;
    this.getComponent = getComponent;
    this.getHeader = getHeader;
    this.name = name;
    this.getEmptyFolderComponent = getEmptyFolderComponent;
    this.isEditable = isEditable;
    this.type = type;
    this.hidden = hidden;
    this.status = status;
  }
}
